import PreRegistration from './PreRegistration'

export default PreRegistration
